import { Box, Divider, List, ListItem, Tab, Tabs, Tooltip, Typography } from '@mui/material'
import type { PrizeToImport } from 'types/Prize'
import type { ReactNode } from 'react'
import { useState } from 'react'

const PrizeListItem = ({ label, value }: { label: ReactNode; value: ReactNode }) => (
  <ListItem sx={{ justifyContent: 'space-between', p: 0 }}>
    <Typography variant="body2" fontWeight={500} color="grey.600">
      {label}
    </Typography>
    <Typography variant="h6" component="b" fontWeight={600} color="grey.900">
      {value}
    </Typography>
  </ListItem>
)

const PrizeTabContent = ({ prize, selectedPrize }: { prize: PrizeToImport; selectedPrize: string | null }) => {
  if (selectedPrize !== prize.name) {
    return null
  }

  return (
    <List>
      <PrizeListItem label="Total amount" value={prize.totalAmount} />
      <PrizeListItem label="Sent" value={prize.statuses.find(item => item.status === 'emitted')?.count || 0} />
      <PrizeListItem label="Reserved" value={prize.statuses.find(item => item.status === 'reserved')?.count || 0} />
      <PrizeListItem label="Available" value={prize.statuses.find(item => item.status === 'free')?.count || 0} />
    </List>
  )
}

export const PrizeTabs = ({ prizes, colors }: { prizes: PrizeToImport[]; colors: string[] }): JSX.Element => {
  const [selectedPrize, setPrize] = useState(prizes[0]?.name || null)

  return (
    <Box>
      <Typography variant="h6" component="h3" fontWeight={600}>
        Overview
      </Typography>
      <Typography variant="body2" component="p">
        Manage and track your prizes.
      </Typography>
      <Divider sx={{ my: 1 }} />
      <Tabs
        // variant="scrollable"
        // scrollButtons
        value={selectedPrize}
        TabScrollButtonProps={{
          sx: {
            width: 24,
          },
        }}
        onChange={(_, val) => {
          setPrize(val)
        }}
        sx={{
          position: 'relative',
          width: 320,
          flexGrow: 0,
          gap: 1.25,
          // '.MuiTabs-indicator': {
          //   backgroundColor:
          //     colors[(prizes.findIndex(item => item.name === selectedPrize) + colors.length) % colors.length],
          // },
          // '& .MuiTabs-scrollButtons': {
          //   position: 'absolute',
          //   zIndex: 1,
          //   opacity: 0,
          //   top: '0',
          //   height: '100%',
          //   backgroundColor: 'rgba(255,255,255,0.7)',
          // },
          // '&:hover .MuiTabs-scrollButtons': {
          //   opacity: 1,
          // },
          // '& .MuiTabs-scrollButtons:first-of-type': {
          //   left: 0,
          // },
          // '& .MuiTabs-scrollButtons:last-of-type': {
          //   right: 0,
          // },
        }}
      >
        {prizes.map((prize, idx) => {
          return (
            <Tab
              sx={{
                textTransform: 'none',
                p: 1,
                fontWeight: 600,
                minWidth: 0,
                maxWidth: 320 / prizes.length,
                width: 320 / prizes.length,
              }}
              key={prize.id}
              label={
                <Tooltip title={prize.name}>
                  <span
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      maxWidth: '100%',
                      width: '100%',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {prize.name}
                  </span>
                </Tooltip>
              }
              value={prize.name}
            />
          )
        })}
      </Tabs>
      {prizes.map(prize => (
        <PrizeTabContent key={prize.id} prize={prize} selectedPrize={selectedPrize} />
      ))}
    </Box>
  )
}
